import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import RadioButton from '@wix/da-a11y/pkg/components/formControls/RadioButton';
import { useFacet } from '../../common';
import FacetContent from '../../lego/FacetContent';
const FacetRadioButton = (unprocessedProps)=>{
    var _unprocessedProps_selected;
    const _useFacet = useFacet(_object_spread_props(_object_spread({}, unprocessedProps), {
        selected: (_unprocessedProps_selected = unprocessedProps.selected) !== null && _unprocessedProps_selected !== void 0 ? _unprocessedProps_selected : unprocessedProps.checked
    })), { rootComponentProps, contentComponentProps, implementationSpecificProps: { checked } } = _useFacet, implementationSpecificProps = _object_without_properties(_useFacet.implementationSpecificProps, [
        "checked"
    ]);
    var _unprocessedProps_selected1;
    return /*#__PURE__*/ React.createElement(RadioButton, _object_spread({
        // FacetContent has a required `children: string` type on it, so that forces the consumer to provide the necessary text
        hasAccessibleText: true,
        checked: !!((_unprocessedProps_selected1 = unprocessedProps.selected) !== null && _unprocessedProps_selected1 !== void 0 ? _unprocessedProps_selected1 : checked)
    }, rootComponentProps, implementationSpecificProps), /*#__PURE__*/ React.createElement(FacetContent, contentComponentProps));
};
FacetRadioButton.displayName = 'FacetRadioButton';
export default FacetRadioButton;
